export default __webpack_public_path__ + "static/media/img-2.7a23df31.jpg";